import script from "./PharmacyAssignmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PharmacyAssignmentModal.vue?vue&type=script&setup=true&lang=js"

import "./PharmacyAssignmentModal.vue?vue&type=style&index=0&id=56e4628c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e4628c"]])

export default __exports__